import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '../../components/form-fields/form.module';
import { LoginComponent } from './login.component';
import { routing } from './login.routing';
import {
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaModule,
  RecaptchaV3Module,
} from 'ng-recaptcha';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { MessagesModule } from 'primeng/messages';
import { SharedModule } from '../../components/shared/shared.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { environment } from '../../../environments/environment';
import { MessageModule } from 'primeng/message';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormModule,
    SharedModule,
    RecaptchaV3Module,
    RecaptchaModule,
    routing,
    ButtonModule,
    RippleModule,
    MessagesModule,
    SharedModule,
    SharedModule,
    OverlayPanelModule,
    MessageModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.captchaKey,
    },
  ],
  declarations: [LoginComponent],
})
export class LoginModule {}
